$(document).ready(function() {
    $('.twentytwenty-container').twentytwenty();
});


